// extracted by mini-css-extract-plugin
export default {"select_share":"index_select_share_-JwH0","header":"index_header_84r1r"};